"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { DebugCaptureIcon } from "@/components/icons/sidebar-icon";
import { DEBUG_CAPTURE_Z } from "./layers";
import { enableDebugCapturePointerEvents, getDebugCapturePortalRoot } from "./portal";
interface DebugCaptureFloatingButtonProps {
  isArmed: boolean;
  onToggle: () => void;
}
function applyFloatingStyles(element: HTMLButtonElement) {
  element.style.setProperty("position", "fixed", "important");
  element.style.setProperty("left", "16px", "important");
  element.style.setProperty("bottom", "72px", "important");
  element.style.setProperty("right", "auto", "important");
  element.style.setProperty("top", "auto", "important");
  element.style.setProperty("z-index", String(DEBUG_CAPTURE_Z.floatingButton), "important");
  element.style.setProperty("width", "36px", "important");
  element.style.setProperty("height", "36px", "important");
  element.style.setProperty("margin", "0", "important");
  element.style.setProperty("padding", "0", "important");
  enableDebugCapturePointerEvents(element);
}
export function DebugCaptureFloatingButton(t0) {
  const $ = _c(8);
  const {
    isArmed,
    onToggle
  } = t0;
  const [mounted, setMounted] = useState(false);
  const buttonRef = _temp;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!mounted) {
    return null;
  }
  const t3 = isArmed ? "Cancel debug capture" : "Debug capture";
  const t4 = isArmed ? "Cancel (Esc or Alt+Ctrl+B)" : "Debug capture (Alt+Ctrl+B)";
  const t5 = `flex items-center justify-center rounded-full border-2 border-border bg-muted shadow-[0_4px_14px_hsl(var(--overlay)/0.35)] transition-all duration-200 hover:scale-105 hover:bg-accent active:scale-95 ${isArmed ? "ring-2 ring-red-500" : ""}`;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DebugCaptureIcon color="#EF4444" size={16} />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== onToggle || $[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t7 = createPortal(<button ref={buttonRef} type="button" data-debug-capture-trigger={true} aria-label={t3} title={t4} onClick={onToggle} className={t5}>{t6}</button>, getDebugCapturePortalRoot());
    $[3] = onToggle;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}
function _temp(node) {
  if (node) {
    applyFloatingStyles(node);
  }
}